import React from 'react';
import MaskedInput from 'react-text-mask';

import { FormikTextField } from '../components/utils/fields';

import { FieldContainerProps } from './FieldContainer';

import { FieldWrapperProps } from 'components/fields/FieldWrapper';
import { MASK_PHONE_US } from 'common/modules/mask-text/masks';
import { phoneNumberValidator } from 'common/modules/form-validation/validators';

export type PhoneFieldProps = FieldContainerProps &
    FieldWrapperProps &
    React.InputHTMLAttributes<HTMLInputElement> & {
        inputRef?: React.Ref<HTMLInputElement>;
    };

export const PhoneField = (props: PhoneFieldProps) => {
    const { label } = props;

    return (
        <MaskedInput
            {...props}
            mask={MASK_PHONE_US}
            guide={false}
            render={(ref, _props) => (
                <FormikTextField
                    {..._props}
                    inputRef={ref}
                    type="tel"
                    validate={phoneNumberValidator}
                    label={label}
                    name={props.name || ''}
                />
            )}
        />
    );
};
